export class MessageDto {
  isUser;
  content;
  hasImage;
  imageContent;

  constructor(isUser, content) {
    this.isUser = isUser;
    this.content = content;
  }

  setHasImage(hasImage){
	this.hasImage=hasImage;
  }

  setImageContent(imageContent){
	this.imageContent=imageContent;
  }
}